import { Component, OnInit } from '@angular/core';
import { IUser } from '@shared/models/login.model';
import { fromEvent } from 'rxjs';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-short-actions',
  templateUrl: './short-actions.component.html',
  styleUrls: ['./short-actions.component.scss']
})
export class ShortActionsComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public selectorActive = false;
  user: IUser;
  constructor(private userService: UserService) {
    super();
    this.user = this.userService.userInfo;
  }

  ngOnInit() {
    this.subs.add(
      fromEvent(window, 'click').subscribe(
        (e: any) =>
          (this.selectorActive = document
            .getElementById('clickbox')
            .contains(e.target))
      )
    );
  }
}
